const ar = {
  dir: "rtl",
  langLabel: "English",
  nav: { home: "الرئيسية", about: "من نحن", services: "الخدمات", locations: "المواقع", sectors: "القطاعات", contact: "اتصل بنا", quote: "اطلب عرض سعر", menu: "القائمة", close: "إغلاق" },
  common: {
    requestQuote: "اطلب عرض سعر", ourServices: "خدماتنا", learnMore: "عرض الخدمة", allServices: "جميع الخدمات",
    included: "ما تشمله الخدمة", whoFor: "لمن هذه الخدمة", back: "العودة إلى الخدمات", placeholder: "يُحدَّد لاحقاً",
    whatsapp: "تواصل عبر واتساب", noPrices: "تُرسل الأسعار بالبريد الإلكتروني للاستفسارات المؤهلة.", reply24: "نرد بعرض سعر مكتوب خلال 24 ساعة.",
    servicesAtSite: "الخدمات المتاحة في هذا الموقع", whatWeOperate: "ما نشغّله هنا", siteFacts: "بيانات الموقع", viewLocation: "عرض الموقع",
    logoPlaceholder: "مكان الشعار",
  },
  home: {
    eyebrow: "مشغّل مرخّص في المناطق الحرة · بنغازي، ليبيا",
    heroLines: ["خدمات لوجستية في المناطق الحرة بليبيا\u00A0—", "من الرصيف", "إلى مستودعك."],
    heroSub: "عمليات مرخّصة في منطقتي جوليانا وسرت الحرتين. تخزين ومناولة وتنسيق جمركي ونقل إلى جميع أنحاء ليبيا، بعقد واحد.",
    scroll: "مرّر",
    capabilities: ["موقعان في المناطق الحرة", "تخزين تحت نظام الإيداع الجمركي", "مناولة الحاويات والمركبات والمنصّات", "التخليص الجمركي والمستندات", "نقل إلى جميع أنحاء ليبيا", "العربية والإنجليزية"],
    servicesEyebrow: "الخدمات", servicesTitle: "خدمات لوجستية متكاملة في الموانئ والمناطق الحرة.",
    servicesIntro: "ست خدمات ومشغّل واحد. كل خدمة متاحة منفردة أو ضمن عقد واحد.",
    whyEyebrow: "لماذا أطلس بريدج", whyTitle: "شركة جديدة، بناها أشخاص يمارسون هذا العمل منذ عقود.",
    why: [
      { t: "فريق ذو خبرة", d: "مخلّصون جمركيون ومديرو عمليات بخبرة تتراوح بين 20 و30 عاماً في الجمارك وعمليات الموانئ الليبية." },
      { t: "موقعان في المناطق الحرة", d: "في الشرق والوسط — لتغطية بنغازي والهلال النفطي والممر الأوسط." },
      { t: "تأجيل الرسوم الجمركية", d: "تُحفظ البضائع تحت نظام الإيداع، ولا تُدفع الرسوم إلا عند دخولها السوق الليبي، أو لا تُدفع إطلاقاً عند إعادة تصديرها." },
      { t: "جهة اتصال واحدة وفاتورة واحدة", d: "التخزين والمناولة والتخليص والتسليم تُدار جميعها داخلياً." },
    ],
    locEyebrow: "المواقع", locTitle: "في شرق الساحل الليبي ووسطه.",
    locIntro: "موقعان مرخّصان في المناطق الحرة يخدمان بنغازي والهلال النفطي والممر الأوسط.",
    ctaEyebrow: "الاستفسارات", ctaTitle: "أخبرنا بما تنقله، وسنرسل لك عرض سعر مكتوباً خلال 24 ساعة.",
    ctaNote: "لا ننشر الأسعار. تُرسل الأسعار بالبريد الإلكتروني للاستفسارات المؤهلة.",
    fullForm: "هل تريد إرفاق قوائم التعبئة أو المخططات؟ استخدم نموذج طلب العرض الكامل.",
  },
  locationsShort: {
    julyana: { name: "منطقة جوليانا الحرة", city: "بنغازي", d: "قاعدتنا الشرقية بجوار ميناء بنغازي — مستودعات تحت الإيداع الجمركي وساحات تخزين مكشوفة ومناولة البضائع للمستوردين والمقاولين وخطوط الشحن." },
    sirte: { name: "منطقة سرت الحرة", city: "سرت", d: "موقعنا الأوسط على خليج سرت — قريب من الهلال النفطي والممر الأوسط، مع ساحات تخزين ومساحات تشوين." },
  },
  map: { title: "خريطة ليبيا توضّح مواقع أطلس بريدج للخدمات اللوجستية في المناطق الحرة", tripoli: "طرابلس", tobruk: "طبرق", sea: "البحر المتوسط", oil: "الهلال النفطي" },
  about: {
    eyebrow: "من نحن", title: "بديل موثّق للتخزين غير الرسمي.",
    intro: "أطلس بريدج للخدمات اللوجستية شركة ليبية مسجّلة في بنغازي ومرخّصة للعمل داخل المناطق الحرة.",
    whoTitle: "من نحن",
    who: [
      "تأسسنا لنقدّم للمستوردين والمقاولين وشركات خدمات النفط والغاز وخطوط الشحن بديلاً مهنياً وموثّقاً للتخزين غير الرسمي.",
      "منشآتنا وعملياتنا في منطقة جوليانا الحرة ببنغازي ومنطقة سرت الحرة. من الرصيف حتى نقطة التسليم النهائية، تُسجَّل كل حركة وتُصوَّر ويُوقَّع عليها.",
      "الشركة جديدة، أما القائمون عليها فليسوا كذلك: يمتلك مخلّصونا الجمركيون ومديرو العمليات لدينا خبرة تتراوح بين 20 و30 عاماً لكل منهم في الجمارك الليبية وعمليات الموانئ والخدمات اللوجستية في المناطق الحرة.",
    ],
    teamEyebrow: "فريقنا", teamTitle: "عقود من الخبرة المشتركة في الجمارك والموانئ والمناطق الحرة الليبية.",
    teamNote: "ستُضاف الأسماء والصور لاحقاً.",
    team: [
      { role: "المدير العام", bio: "يقود الشركة وعلاقاتها مع سلطات المناطق الحرة والموانئ. خلفية في عمليات الموانئ الليبية والخدمات اللوجستية في المناطق الحرة." },
      { role: "مدير العمليات", bio: "يدير الساحات والمستودعات والمعدات والبوابة. عقود من الخبرة في إدارة مناولة البضائع وتخزينها في الموانئ الليبية." },
      { role: "رئيس الجمارك والتخليص", bio: "ينسّق البيانات الجمركية مع المخلّصين المرخّصين ومصلحة الجمارك. خبرة طويلة في الإجراءات الجمركية الليبية." },
      { role: "المدير التجاري", bio: "نقطة اتصالك الأولى لعروض الأسعار والعقود وتخطيط الخدمات في موقعي المنطقتين الحرتين." },
    ],
    nameTbc: "يُحدَّد الاسم لاحقاً",
    processEyebrow: "كيف نعمل", processTitle: "أربع خطوات، وكل خطوة موثّقة.",
    process: [
      { t: "الإشعار المسبق", d: "ترسل تفاصيل الشحنة ومستنداتها قبل الوصول ليكون الموقع والمعدات والأوراق جاهزة." },
      { t: "الاستلام والفحص", d: "تُفحص البضائع عند البوابة، وتُتحقق الأختام، وتُسجَّل حالتها بالصور." },
      { t: "التخزين تحت الإيداع", d: "تُحفظ البضائع تحت الإيداع الجمركي في مواقع مسجّلة، مع تقارير مخزون شهرية وجرد دوري." },
      { t: "الإفراج", d: "لا يُفرج عن البضائع إلا بموجب أمر موقّع واستكمال التخليص الجمركي المطلوب." },
    ],
    complianceEyebrow: "الامتثال والمعايير", complianceTitle: "ما نقبله، وما نرفضه.",
    compliance: [
      { t: "التحقق من العملاء", d: "يُتحقق من كل عميل ومرسَل إليه قبل قبول البضائع." },
      { t: "توثيق الاستلام والإفراج", d: "إيصالات استلام، وإيصالات تبادل، وصور، وأوامر إفراج موقّعة لكل حركة." },
      { t: "عمليات مؤمَّنة", d: "عملياتنا مؤمَّنة، ويمكن ترتيب التأمين على البضائع عند الطلب." },
      { t: "البضائع الخطرة", d: "تُقبل فقط ضمن الفئات المعتمدة وفي المناطق المخصّصة لها." },
      { t: "البضائع المحظورة والخاضعة للعقوبات", d: "مرفوضة، دون استثناء." },
    ],
  },
  servicesPage: { eyebrow: "الخدمات", title: "خدمات لوجستية متكاملة في الموانئ والمناطق الحرة.", intro: "تخزين ومناولة وتنسيق جمركي ونقل ودعم سلاسل الإمداد واستقبال نفايات السفن — منفردة أو ضمن عقد واحد." },
  services: [
    {
      slug: "warehousing-storage", img: "/img/warehouse.jpg", title: "التخزين والمستودعات",
      short: "مستودعات مغطاة تحت الإيداع الجمركي، وساحات تخزين مكشوفة ومساحات تشوين، مع مواقع مسجّلة وتقارير مخزون شهرية.",
      intro: "التخزين تحت الإيداع داخل المنطقة الحرة يعني أن بضائعك آمنة وموثّقة ورسومها مؤجلة إلى أن تقرر وجهتها التالية.",
      included: [
        "مستودعات مغطاة تحت الإيداع الجمركي مزوّدة بأرفف ومواقع منصّات مسجّلة",
        "ساحات تخزين مكشوفة للحاويات والمركبات والآليات والحديد وبضائع المشاريع",
        "أقسام ساحات مسيّجة مخصّصة ومناطق مسوّرة بعقود سنوية",
        "مساحات تشوين للمقاولين وشركات خدمات النفط والغاز",
        "إدارة المخزون وأنظمة المخزون وتقارير مخزون شهرية وجرد دوري",
        "حراسة على مدار الساعة، وأسوار محيطة، وكاميرات مراقبة، وتحكم في الدخول، وحماية من الحريق",
      ],
      forWho: "المستوردون والموزعون الذين يحتفظون بمخزون، والمقاولون وشركات خدمات النفط والغاز الذين يحتاجون إلى مساحات تشوين، والمصنّعون الذين يحتفظون بمخزون إقليمي.",
    },
    {
      slug: "cargo-handling", img: "/img/handling.jpg", title: "مناولة البضائع",
      short: "رفع الحاويات وإنزالها، وتعبئتها وتفريغها، والبضائع العامة، والتحويل المباشر، وتقارير الحالة المصوّرة.",
      intro: "كل حاوية ومنصّة تعبر بوابتنا تُوزن وتُفحص وتُصوَّر وتُناول بالمعدات المناسبة.",
      included: [
        "رفع الحاويات وإنزالها بالرافعات الشوكية للحاويات (ريتش ستاكر)",
        "تفريغ الحاويات وتعبئتها، للبضائع على المنصّات والبضائع السائبة",
        "تخزين المنصّات وانتقاؤها، والتحويل المباشر (كروس دوكينغ)",
        "مناولة البضائع العامة والثقيلة، وربطها وتثبيتها",
        "ميزان شاحنات، وفحص عند البوابة، والتحقق من الأختام، وتقارير حالة مصوّرة",
        "التجميع والتغليف وإعادة التغليف والتغليف الحراري ووضع الملصقات (بما فيها الملصقات العربية)",
      ],
      forWho: "المستوردون، وخطوط الشحن ووكلاؤها، ومستوردو المركبات والآليات، وأصحاب بضائع المشاريع.",
    },
    {
      slug: "customs-documentation", img: "/img/customs.jpg", title: "الجمارك والمستندات",
      short: "الدخول إلى المنطقة الحرة تحت الإيداع، والاستيراد وإعادة التصدير والعبور — بالتنسيق مع سلطات الجمارك والمنطقة الحرة.",
      intro: "ننسّق الأوراق لتتحرك بضائعك دون تأخير، وتحصل على مجموعة مستندات كاملة لكل شحنة.",
      included: [
        "بيانات الدخول إلى المنطقة الحرة تحت الإيداع والاستيراد وإعادة التصدير والعبور",
        "التنسيق مع سلطات الجمارك والمنطقة الحرة",
        "استلام أذونات التسليم ودفع رسوم الميناء وخطوط الشحن نيابةً عن العميل",
        "مجموعة مستندات كاملة لكل شحنة: إيصالات استلام، وإيصالات تبادل، وقوائم تعبئة، وصور، وإثبات تسليم",
      ],
      note: "تُقدَّم البيانات الجمركية عن طريق مخلّصين جمركيين مرخّصين.",
      forWho: "أي مستورد أو مصدّر أو شاحن عبور يستخدم بنغازي أو سرت، وخاصة من لا يملكون موظفي تخليص في ليبيا.",
    },
    {
      slug: "transport-freight", img: "/img/transport.jpg", title: "النقل والشحن",
      short: "نقل مكوكي من الميناء، وتسليم في جميع أنحاء ليبيا، وشحن وتنسيق، وتأجير معدات مع مشغّليها.",
      intro: "من بوابة الميناء إلى موقع مشروع في الصحراء، نخطط للنقل وننسّقه.",
      included: [
        "نقل مكوكي من الميناء إلى المستودع وإعادة الحاويات الفارغة",
        "التسليم في جميع أنحاء ليبيا — الشرق والغرب والطرق الصحراوية الجنوبية",
        "الشحن والتنسيق بين الموردين والمستوردين والمصدّرين والناقلين والمستودعات والموانئ",
        "تأجير المعدات والآليات: رافعات شوكية، ورافعات حاويات، ومعدات مناولة، مع المشغّلين",
      ],
      forWho: "المستوردون والمقاولون وشركات خدمات النفط والغاز والمنظمات الإنسانية التي تنقل البضائع إلى الداخل.",
    },
    {
      slug: "supply-chain-support", img: "/img/supply.jpg", title: "دعم سلاسل الإمداد",
      short: "إدارة سلاسل الإمداد، وتنسيق المشتريات، والوكالة اللوجستية، والتتبع، والتقارير، والاستشارات.",
      intro: "للشركات العاملة داخل المناطق الحرة، يمكننا إدارة سلسلة الإمداد التي تقف خلف أعمالكم أو دعمها.",
      included: [
        "إدارة سلاسل الإمداد للمصانع والمستودعات والمشاريع داخل المناطق الحرة",
        "تنسيق المشتريات والإمدادات لشركات المناطق الحرة",
        "خدمات الوكالة اللوجستية وتمثيل العملاء أمام مقدّمي الخدمات",
        "التتبع الإلكتروني للشحنات والحاويات، وأنظمة المخزون والمستودعات",
        "التقارير والإحصاءات الخاصة بحركة البضائع",
        "الاستشارات والدراسات اللوجستية في النقل والتخزين والمناولة وسلاسل الإمداد",
      ],
      forWho: "شركات المناطق الحرة والمصنّعون وأصحاب المشاريع والشركات الأجنبية الداخلة إلى السوق الليبي.",
    },
    {
      slug: "port-ship-waste", img: "/img/waste.jpg", title: "خدمات نفايات الموانئ والسفن",
      short: "خدمة متخصصة لخطوط الشحن والوكلاء وسلطات الموانئ: استقبال نفايات السفن بموجب التصاريح.",
      intro: "خدمة متخصصة لخطوط الشحن والوكلاء وسلطات الموانئ: استقبال النفايات الناتجة عن السفن في الميناء، بموجب تصاريح الجهات المختصة.",
      included: [
        "استقبال وجمع النفايات الناتجة عن السفن في الميناء، بموجب تصاريح الجهات المختصة",
        "فرز المواد القابلة لإعادة الاستخدام والتدوير",
        "نقل مرخّص إلى مرافق المعالجة أو التدوير أو التخلص النهائي المعتمدة",
        "توفير الحاويات والصناديق والمعدات وفق المتطلبات البيئية",
        "سجلات الاستلام والتسليم، وإصدار شهادات استقبال النفايات على النماذج المعتمدة",
      ],
      forWho: "خطوط الشحن ووكلاء السفن وسلطات الموانئ.",
    },
  ],
  locationsPage: {
    eyebrow: "المواقع", title: "موقعان مرخّصان في المناطق الحرة.", intro: "في الشرق والوسط — لتغطية بنغازي والهلال النفطي والممر الأوسط.",
    specLabels: { site: "مساحة الموقع", covered: "المساحة المغطاة", yard: "مساحة الساحة", equipment: "المعدات", terminal: "المسافة إلى المحطة" },
    zones: [
      {
        id: "julyana", name: "منطقة جوليانا الحرة", city: "بنغازي", img: "/img/julyana.jpg",
        desc: "تقع منطقة جوليانا الحرة في بنغازي، المدينة والميناء الرئيسيين في شرق ليبيا. وهي البوابة الشرقية للبضائع الداخلة إلى البلاد تحت الإيداع، وقاعدة لإعادة التصدير والعبور.",
        operate: "قاعدتنا الشرقية: مستودعات مغطاة تحت الإيداع الجمركي، وساحات تخزين مكشوفة للحاويات والمركبات وبضائع المشاريع، ومناولة الحاويات.",
        services: ["التخزين والمستودعات", "مناولة البضائع", "الجمارك والمستندات", "النقل والشحن", "دعم سلاسل الإمداد", "خدمات نفايات الموانئ والسفن"],
      },
      {
        id: "sirte", name: "منطقة سرت الحرة", city: "سرت", img: "/img/sirte.jpg",
        desc: "تقع منطقة سرت الحرة على خليج سرت في وسط ليبيا، بين الشرق والغرب وقريباً من الهلال النفطي. وهي تخدم الممر الأوسط والطرق الجنوبية.",
        operate: "موقعنا الأوسط: ساحات تخزين ومساحات تشوين للمقاولين وشركات خدمات النفط والغاز، مع المناولة والنقل إلى الوجهة.",
        services: ["التخزين والمستودعات", "مناولة البضائع", "الجمارك والمستندات", "النقل والشحن", "دعم سلاسل الإمداد"],
      },
    ],
  },
  sectorsPage: {
    eyebrow: "القطاعات التي نخدمها", title: "لمن نعمل.", intro: "صُمّمت خدماتنا للجهات التي تنقل البضائع وتخزّنها في ليبيا.",
    sectors: [
      { t: "المستوردون والموزعون", d: "تخزين تحت الإيداع بالقرب من الميناء، ولا تُدفع الرسوم إلا عند دخول البضائع السوق." },
      { t: "شركات خدمات النفط والغاز", d: "مساحات تشوين وساحات تخزين للمعدات وقطع الغيار، بالقرب من الهلال النفطي." },
      { t: "مقاولو البناء وإعادة الإعمار", d: "تخزين ومناولة وتسليم إلى المواقع للحديد والآليات وبضائع المشاريع." },
      { t: "خطوط الشحن والوكلاء", d: "مناولة الحاويات وإعادة الفارغ منها والمستندات واستقبال نفايات السفن." },
      { t: "مستوردو المركبات والآليات", d: "تخزين آمن في ساحات مكشوفة مع تقارير حالة وإفراج مضبوط." },
      { t: "المصنّعون الذين يحتفظون بمخزون إقليمي", d: "مخزون مؤجل الرسوم في ليبيا، مع إمكانية إعادة التصدير إن لم يُبع." },
      { t: "الجهات الحكومية والمنظمات الإنسانية", d: "تخزين موثّق وتسليم في جميع أنحاء ليبيا، بما في ذلك الطرق الجنوبية." },
    ],
  },
  quote: {
    eyebrow: "اطلب عرض سعر", title: "أخبرنا عن بضائعك.", reply: "نرد بعرض سعر مكتوب خلال 24 ساعة.",
    side: ["لا تُنشر الأسعار على هذا الموقع.", "تُرسل الأسعار بالبريد الإلكتروني للاستفسارات المؤهلة.", "تُستخدم بياناتك فقط لإعداد عرض السعر."],
    f: {
      company: "اسم الشركة", contact: "اسم جهة الاتصال", email: "البريد الإلكتروني", phone: "الهاتف", country: "الدولة",
      services: "الخدمة المطلوبة", servicesHint: "اختر خدمة أو أكثر", location: "الموقع",
      locJulyana: "منطقة جوليانا الحرة", locSirte: "منطقة سرت الحرة", locUnsure: "غير متأكد",
      cargo: "نوع البضائع", cargoPh: "مثال: حاويات 40 قدماً، بضائع على منصّات، مركبات",
      volume: "الحجم التقديري", volumePh: "مثال: 20 حاوية مكافئة، 300 منصّة، 1,200 م²",
      duration: "مدة التخزين المتوقعة", durationPh: "مثال: 3 أشهر",
      message: "الرسالة", files: "قوائم التعبئة أو المخططات", filesHint: "PDF، صور، Excel، Word، DWG — حتى 5 ملفات، 10 ميغابايت لكل ملف",
      choose: "اختر الملفات", remove: "إزالة", submit: "إرسال الاستفسار", sending: "جارٍ الإرسال…",
    },
    required: "حقل مطلوب", invalidEmail: "أدخل بريداً إلكترونياً صحيحاً", pickService: "اختر خدمة واحدة على الأقل",
    successTitle: "شكراً لك. تم استلام استفسارك.", successBody: "نرد بعرض سعر مكتوب خلال 24 ساعة.", ref: "الرقم المرجعي", another: "إرسال استفسار آخر",
    error: "حدث خطأ ما. يرجى المحاولة مرة أخرى أو مراسلتنا بالبريد الإلكتروني.",
  },
  contact: {
    eyebrow: "اتصل بنا", title: "تحدّث إلى الفريق.",
    head: "المكتب الرئيسي", headAddr: "بنغازي، ليبيا",
    ops: "العمليات", opsList: ["منطقة جوليانا الحرة، بنغازي", "منطقة سرت الحرة"],
    phone: "الهاتف", whatsapp: "واتساب", emails: "البريد الإلكتروني",
    emailLabels: { info: "عام", support: "الدعم", ops: "العمليات", sales: "عروض الأسعار", docs: "المستندات" },
    hours: "ساعات العمل", hoursVal: "الأحد – الخميس", hoursNote: "تعمل الساحة خارج ساعات الدوام بالترتيب المسبق.",
    formTitle: "أرسل رسالة", mapTitle: "خريطة بنغازي، ليبيا",
  },
  footer: {
    desc: "مشغّل لوجستي مرخّص في المناطق الحرة بليبيا — تخزين ومناولة وتنسيق جمركي ونقل.",
    locations: "المواقع", contact: "اتصل بنا", services: "الخدمات", company: "الشركة",
    cr: "رقم السجل التجاري", lic: "رقم ترخيص المنطقة الحرة", rights: "جميع الحقوق محفوظة.",
  },
  seo: {
    home: ["الخدمات اللوجستية في المناطق الحرة بليبيا | أطلس بريدج", "خدمات لوجستية مرخّصة في منطقة جوليانا الحرة (بنغازي) ومنطقة سرت الحرة: مستودعات تحت الإيداع في بنغازي، تخزين الحاويات، التخليص الجمركي في ليبيا والنقل."],
    about: ["من نحن | أطلس بريدج للخدمات اللوجستية", "مشغّل لوجستي ليبي مرخّص في المناطق الحرة، أسّسه مخلّصون ومديرو عمليات بخبرة 20–30 عاماً في الجمارك والموانئ الليبية."],
    services: ["الخدمات | مستودعات تحت الإيداع في بنغازي والتخليص الجمركي في ليبيا", "التخزين ومناولة البضائع والتنسيق الجمركي والنقل ودعم سلاسل الإمداد وخدمات نفايات السفن في منطقتي جوليانا وسرت الحرتين."],
    locations: ["منطقة جوليانا الحرة ومنطقة سرت الحرة | أطلس بريدج", "مواقعنا المرخّصة في منطقة جوليانا الحرة ببنغازي ومنطقة سرت الحرة — تخزين تحت الإيداع وتخزين الحاويات في بنغازي والمناولة."],
    sectors: ["القطاعات التي نخدمها | أطلس بريدج ليبيا", "خدمات لوجستية في المناطق الحرة للمستوردين وشركات النفط والغاز والمقاولين وخطوط الشحن والمنظمات الإنسانية في ليبيا."],
    quote: ["اطلب عرض سعر | الخدمات اللوجستية في المناطق الحرة بليبيا", "اطلب عرض سعر مكتوباً للتخزين تحت الإيداع وتخزين الحاويات في بنغازي والمناولة والتخليص الجمركي في ليبيا. الرد خلال 24 ساعة."],
    contact: ["اتصل بنا | أطلس بريدج للخدمات اللوجستية، بنغازي", "تواصل مع أطلس بريدج في بنغازي. عمليات في منطقة جوليانا الحرة ومنطقة سرت الحرة. أرسل استفسارك عبر الموقع."],
    notFound: ["الصفحة غير موجودة | أطلس بريدج", "تعذّر العثور على الصفحة المطلوبة."],
  },
  notFound: { title: "الصفحة غير موجودة.", back: "العودة إلى الرئيسية" },
};

export default ar;
